module.exports = __webpack_public_path__ + "img/1.547f0996.png";